import { GameId } from '@bg-shared/enums/GameId';
import { ClassicGameDefinition } from '@bg-shared/utils/ClassicGameDefinition';
import { ISelectedGameModel } from './interfaces';

export const selectedGamesSelectors = {
    getOptionsIds: (state: ISelectedGameModel[]) => state.map((game) => game.optionId),

    getGamesIds: (state: ISelectedGameModel[]) => state.map((game) => game.gameId),

    getCount: (state: ISelectedGameModel[]) => state.length,

    getBatchBetsCount: (state: ISelectedGameModel[]) =>
        state.filter((game) => game.isBatchItem).length,

    getNotBatchedOptions: (state: ISelectedGameModel[]) =>
        state.filter((game) => !game.isBatchItem),

    getOptions: (gameId: GameId) => (state: ISelectedGameModel[]) =>
        ClassicGameDefinition.isInstantLucky7(gameId)
            ? state.filter((game) => game.isBatchItem)
            : state.filter((game) => !game.isBatchItem),
};
